import * as yup from 'yup';
import { CnpjValidator } from './cnpj';

yup.addMethod(yup.string, 'cnpj', function (message = 'CNPJ inválido') {
    return this.test('cnpj', message, function (value) {
        const { path, createError } = this;

        if (!value) return true;

        const cleaned = value.toString().replace(/[^a-zA-Z0-9]/g, '');

        // CNPJ incompleto ainda em digitação — não valida dígito verificador
        if (cleaned.length > 0 && cleaned.length < 14) return true;

        return CnpjValidator(value) || createError({ path, message });
    });
});
